/**
 * Test-only data-source override for the Elastic → AWS migration.
 *
 * Lets the test dashboard request one backend per feature for comparison. It is purely a
 * request hint: the API ignores it in production (and for cache warming), so this file is
 * not a security control. See pge-webdashboard-api2/readme.md for the server-side switches.
 */
export type DataSourceOverride = 'default' | 'elastic' | 'aws';

export const DATA_SOURCE_OVERRIDE_KEY = 'dataSourceOverride';

// Prod API hosts. The selector stays hidden against these even if the enable flag is set,
// because .env.local is tracked in git and could carry the flag into a prod build.
const PROD_API_HOSTS = ['tqqu6arkec', 'n1hoeids8g'];

export const isDataSourceOverrideEnabled = (): boolean => {
  if (process.env.REACT_APP_ENABLE_DATA_SOURCE_OVERRIDE !== 'true')
    return false;
  const apiUrl = process.env.REACT_APP_API_URL ?? '';
  return !PROD_API_HOSTS.some((host) => apiUrl.includes(host));
};

export const getDataSourceOverride = (): DataSourceOverride => {
  if (!isDataSourceOverrideEnabled()) return 'default';
  try {
    const stored = localStorage.getItem(DATA_SOURCE_OVERRIDE_KEY);
    return stored === 'elastic' || stored === 'aws' ? stored : 'default';
  } catch {
    return 'default';
  }
};
